<template>
  <div class="program-documentation-tab">
    <div class="text-h6 q-mb-md">Control Program & Schedule</div>

    <div class="row q-col-gutter-md">
      <div class="col-12 col-md-6">
        <q-card flat bordered>
          <q-card-section>
            <div class="text-subtitle2 q-mb-sm">Operating Schedule</div>

            <q-input
              :model-value="modelValue.program_schedule?.weekday_start"
              label="Weekday Start Time"
              type="time"
              outlined
              dense
              class="q-mb-sm"
              @update:model-value="updateField('weekday_start', $event)"
            />

            <q-input
              :model-value="modelValue.program_schedule?.weekday_stop"
              label="Weekday Stop Time"
              type="time"
              outlined
              dense
              class="q-mb-sm"
              @update:model-value="updateField('weekday_stop', $event)"
            />

            <q-input
              :model-value="modelValue.program_schedule?.weekend_start"
              label="Weekend Start Time"
              type="time"
              outlined
              dense
              class="q-mb-sm"
              @update:model-value="updateField('weekend_start', $event)"
            />

            <q-input
              :model-value="modelValue.program_schedule?.weekend_stop"
              label="Weekend Stop Time"
              type="time"
              outlined
              dense
              @update:model-value="updateField('weekend_stop', $event)"
            />
          </q-card-section>
        </q-card>
      </div>

      <div class="col-12 col-md-6">
        <q-card flat bordered>
          <q-card-section>
            <div class="text-subtitle2 q-mb-sm">Setpoints</div>

            <q-input
              :model-value="modelValue.program_schedule?.cooling_setpoint"
              label="Cooling Setpoint (°F)"
              type="number"
              outlined
              dense
              class="q-mb-sm"
              @update:model-value="updateField('cooling_setpoint', Number($event))"
            />

            <q-input
              :model-value="modelValue.program_schedule?.heating_setpoint"
              label="Heating Setpoint (°F)"
              type="number"
              outlined
              dense
              class="q-mb-sm"
              @update:model-value="updateField('heating_setpoint', Number($event))"
            />

            <q-input
              :model-value="modelValue.program_schedule?.humidity_setpoint"
              label="Humidity Setpoint (%)"
              type="number"
              outlined
              dense
              class="q-mb-sm"
              @update:model-value="updateField('humidity_setpoint', Number($event))"
            />

            <q-input
              :model-value="modelValue.program_schedule?.co2_setpoint"
              label="CO2 Setpoint (ppm)"
              type="number"
              outlined
              dense
              @update:model-value="updateField('co2_setpoint', Number($event))"
            />
          </q-card-section>
        </q-card>
      </div>
    </div>

    <q-card flat bordered class="q-mt-md">
      <q-card-section>
        <q-input
          :model-value="modelValue.program_schedule?.sequence_of_operations"
          label="Sequence of Operations"
          type="textarea"
          outlined
          rows="6"
          placeholder="Describe the detailed sequence of operations..."
          @update:model-value="updateField('sequence_of_operations', $event)"
        />
      </q-card-section>
    </q-card>
  </div>
</template>

<script setup>
/**
 * Program Documentation Tab Component
 *
 * Displays form for documenting control programs, schedules, and setpoints
 */

  const props = defineProps({
    modelValue: {
      type: Object,
      required: true,
      default: () => ({
        program_schedule: {
          weekday_start: '',
          weekday_stop: '',
          weekend_start: '',
          weekend_stop: '',
          cooling_setpoint: null,
          heating_setpoint: null,
          humidity_setpoint: null,
          co2_setpoint: null,
          sequence_of_operations: '',
        },
      }),
    },
  });

  const emit = defineEmits(['update:program-schedule']);

  function updateField(field, value) {
    emit('update:program-schedule', { field, value });
  }
</script>

<style scoped>
.program-documentation-tab {
  height: 100%;
}
</style>
